import formatTableJson from '@/config/tableComponentParams.js'
import i18n from '@/locales/index'
import { fixNum } from '@/utils/utils'

export default formatTableJson([
  {
    filed: 'identifier',
    label: i18n.t('Device.identifier')
  },
  {
    filed: 'name',
    label: i18n.t('Device.shadowName')
  },
  {
    filed: 'dataType',
    label: i18n.t('Device.dataType')
  },
  {
    filed: 'latestValue',
    label: i18n.t('Device.latestValue'),
    formatFn: function(_, row) {
      if (
        row.latestValue &&
        (row.identifier === 'compressor' ||
          row.identifier === 'defrost' ||
          row.identifier === 'fan' ||
          row.identifier === 'lighting' ||
          row.identifier === 'demisting' ||
          row.identifier === 'door' ||
          row.identifier === 'state')
      ) {
        return row.latestValue.replace(/-?\d+/g, function(s) {
          let num = parseInt(s)
          if (num === 0) {
            return i18n.t('Common.off')
          } else {
            return i18n.t('Common.open')
          }
        })
      } else if (
        row.identifier === 'cabinetTemp' ||
        row.identifier === 'defrostTemp' ||
        row.identifier === 'condenseTemp'
      ) {
        if (row.coefficient && row.latestValue) {
          return fixNum(row.latestValue, row.coefficient)
        } else {
          return row.coefficient && row.latestValue
            ? row.coefficient * row.latestValue
            : row.latestValue || '-'
        }
      } else if (row.identifier === 'tempUnit') {
        return row.latestValue === '0' ? '℉' : '℃'
      } else if (row.dataType === 'float' || row.dataType === 'int') {
        return row.coefficient && row.latestValue
          ? fixNum(row.latestValue, row.coefficient)
          : row.latestValue || '-'
      } else {
        return row.coefficient && row.latestValue
          ? Number(row.coefficient) * Number(row.latestValue)
          : row.latestValue || '-'
      }
    }
  },
  {
    filed: 'reportDate',
    label: i18n.t('Device.reportTime'),
    type: 'time',
    width: '200px'
  }
])
